var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavMenuComponent',{attrs:{"projet_id":_vm.projet_id}}),_c('div',[_c('h1',[_vm._v("Salons commerciaux")]),_c('SalonsTableComponent',{attrs:{"projet_id":_vm.projet_id,"headers":_vm.salon_headers}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }